<template>
  <div class="login-page">
    <div class="loginbox">
      <div class="row">
        <div class="col-md-6 firstcol">
            <div>
                <div class="first">
                    <img src="../assets/img/we-dentify-logo-vertical.svg" alt="" />
                </div>
            </div>
        </div>
        <div class="col-md-6 secondcol" v-if="forgot == 0">
          <div>
            <div class="formcontent">
              <form method="get" action="">
                <div class="col-12">
                  <div class="form-group row">
                    <label>{{ $t('LANGUAGE') }}</label>
                    <select v-model="globals.langCode" class="form-control secondary" @change="setLanguage">
                      <option v-for="lang in globals.languages" :key="lang.langCode" :value="lang.langCode">{{ $t(lang.langName) }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group row">
                    <label>{{ $t('USERNAME')}}</label>
                    <input type="text" v-model="username" class="form-control secondary" :placeholder="$t('USERNAME')">
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group row">
                    <label>{{ $t('PASSWORD')}}</label>
                    <input type="password" v-model="password" v-on:keyup.enter="login" class="form-control secondary" :placeholder="$t('PASSWORD')">
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group row">
                    <b-form-checkbox v-model="rememberMe" class="grey"> {{$t('REMEBERME')}}</b-form-checkbox>
                  </div>
                </div>
                <p class="bg-danger" v-if="loginResponse.error && loginResponse.notice">{{loginResponse.notice}}</p>
                <div class="col-12">
                  <div class="form-group row">
                    <button v-on:click.prevent="login" class="btn btn-primary">{{$t('LOGIN')}}</button>
                  </div>
                </div>
                <div class="clearfix"></div>
              </form>
            </div>
            <div class="forgotpassword">
              <a href="#" v-on:click.prevent="forgot = 1">{{$t('FORGOTPASSWORD')}}</a>
            </div>
          </div>
        </div>
        <div class="col-md-6 secondcol" v-if="forgot == 1">
          <div>
            <div class="formcontent">
              <form method="get" action="">
                <div class="col-12">
                  <a href="#" v-on:click.prevent="forgot = 0"><img src="../assets/img/arrow-right-btn.svg"></a>
                </div>
                <div class="col-12">
                  <p>{{$t('FORGOTPASSWORDDISCLAIMER')}}</p>
                </div>
                <div class="col-12">
                  <div class="form-group row">
                    <label>{{$t('EMAIL')}}</label>
                    <input type="text" v-model="email" v-on:keyup.enter="resetPassword" class="form-control secondary" :placeholder="$t('EMAIL')">
                  </div>
                </div>
                <p class="bg-danger" v-if="formError.error && formError.notice">{{formError.notice}}</p>
                <p class="bg-info" v-if="!formError.error && formError.notice">{{formError.notice}}</p>
                <div class="col-12">
                  <div class="form-group row">
                    <button v-on:click.prevent="resetPassword" class="btn btn-primary"><icon v-if="loading" name="refresh" scale="2" spin></icon> {{$t('RESET')}}</button>
                  </div>
                </div>
                <div class="clearfix"></div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-md-6 secondcol" v-if="forgot == 2">
          <div>
            <div class="formcontent">
              <form method="get" action="">
                <div class="col-12">
                  <a href="#" v-on:click.prevent="forgot = 0"><img src="../assets/img/arrow-right-btn.svg"></a>
                </div>
                <div class="col-12">
                  <p>{{$t('ENTERANDCONFIRMPASSWORD')}}</p>
                </div>
                <div class="col-12">
                  <div class="form-group row">
                    <label>{{ $t('PASSWORD')}}</label>
                    <input type="password" v-model="password" class="form-control secondary" :placeholder="$t('PASSWORD')">
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group row">
                    <label>{{ $t('CONFIRMPASSWORD')}}</label>
                    <input type="password" v-model="confirmpassword" v-on:keyup.enter="confirmPassword" class="form-control secondary" :placeholder="$t('CONFIRMPASSWORD')">
                  </div>
                </div>
                <p class="bg-danger" v-if="formError.error && formError.notice">{{formError.notice}}</p>
                <p class="bg-info" v-if="!formError.error && formError.notice">{{formError.notice}}</p>
                <div class="col-12">
                  <div class="form-group row">
                    <button v-on:click.prevent="confirmPassword" class="btn btn-primary"><icon v-if="loading" name="refresh" scale="2" spin></icon> {{$t('RESET')}}</button>
                  </div>
                </div>
                <div class="clearfix"></div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
	</div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import api from '@/api/users'

export default {
  name: 'Login',
  data: function()
  {
    return {
      username: '',
      password: '',
      confirmpassword: '',
      rememberMe: '',
      forgot: 0,
      email: '',
      formError: {},
      loading: false
    }
  },
  created()
  {
    var me = this;

    if(typeof me.$route.params.verifyCode != 'undefined')
    {
      me.forgot = 2;
    }
  },
  methods:
  {
    ...mapActions({
      actLogin: 'login',
      fetchLanguage: 'fetchLanguage'
    }),
    setLanguage()
    {
      var me = this;
      var selectedLang = me.globals.langCode;
      me.fetchLanguage(selectedLang);
    },
    login: function()
    {
      this.actLogin({username: this.username, password: this.password});
    },
    resetPassword()
    {
      var me = this;

      me.loading = true;
      api.resetPassword({email: me.email}, function(val)
      {
        me.loading = false;
        me.formError = val;
        if(!val.error)
        {
          me.email = '';
        }
      })
    },
    confirmPassword()
    {
      var me = this;

      me.loading = true;
      api.confirmPassword({password: me.password, confirmpassword: me.confirmpassword, verifyCode: me.$route.params.verifyCode}, function(val)
      {
        me.loading = false;
        me.formError = val;
        if(!val.error)
        {
          me.email = '';
        }
      })
    }
  },
  computed:
  {
    ...mapGetters([
      'loginResponse',
      'globals'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue